export { default } from "./ProfileQuery"


// WEBPACK FOOTER //
// ./src/queries/ProfileQuery/index.ts